document.getElementById("size-selector__plus").addEventListener("click", increasePacksize);
document.getElementById("size-selector__minus").addEventListener("click", decreasePacksize);
var currentPack = document.getElementById("current_pack");


function increasePacksize(){
if (currentPack.value < 6){
    currentPack.value = Number(currentPack.value) + 2;
}
else if (currentPack.value < 12)
{
    currentPack.value = Number(currentPack.value) + 6;
}

var triggerchange = new Event('change');
// Dispatch it.
document.getElementById("current_pack").dispatchEvent(triggerchange);

}

function decreasePacksize(){

    if (currentPack.value == 12 ){
        currentPack.value = Number(currentPack.value) - 6;
        
    }
    else if(currentPack.value > 2){
    
        currentPack.value = Number(currentPack.value) - 2;
    }
    var triggerchange = new Event('change');
    // Dispatch it.
    document.getElementById("current_pack").dispatchEvent(triggerchange);

}